import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getFdTenureSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getFdTenure, params)
    yield put(actions.getFdTenureSuccess(response?.data?.data))
    yield put(actions.getFdTenureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getFdTenureFinish())
  }
}

function* addFdTenureSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addFdTenure, body)
    yield put(actions.addFdTenureSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addFdTenureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addFdTenureFinish())
  }
}

function* updateFdTenureSaga(action: ActionModel) {
  try {
    const body: any = action.payload.data
    const response: ResponseModel = yield call(service.updateFdTenure, body, action.payload?.id)
    yield put(actions.updateFdTenureSuccess(response.data?.data))
    yield put(actions.updateFdTenureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateFdTenureFinish())
  }
}

function* deleteFdTenureSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteFdTenure, body)
    yield put(actions.deleteFdTenureSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteFdTenureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteFdTenureFinish())
  }
}

function* singleActivateFdTenure(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleActivateFdTenure,
      selectedOperationIncharge
    )
    yield put({
      type: actionTypes.SINGLE_ACTIVATE_FD_TENURE_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_ACTIVATE_FD_TENURE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_ACTIVATE_FD_TENURE_FINISH})
  }
}

function* singleDeactivateFdTenure(action: ActionModel) {
  try {
    const selectedOperationIncharge: any = action.payload
    const response: ResponseModel = yield call(
      service.singleDeactivateFdTenure,
      selectedOperationIncharge
    )

    yield put({
      type: actionTypes.SINGLE_DEACTIVATE_FD_TENURE_SUCCESS,
      payload: response?.data?.data,
    })
    yield delay(100)
    yield put({type: actionTypes.SINGLE_DEACTIVATE_FD_TENURE_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_DEACTIVATE_FD_TENURE_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_FD_TENURE_START, getFdTenureSaga)
  yield takeLatest(actionTypes.ADD_FD_TENURE_START, addFdTenureSaga)
  yield takeLatest(actionTypes.UPDATE_FD_TENURE_START, updateFdTenureSaga)
  yield takeLatest(actionTypes.DELETE_FD_TENURE_START, deleteFdTenureSaga)
  yield takeLatest(actionTypes.SINGLE_ACTIVATE_FD_TENURE_REQUEST, singleActivateFdTenure)
  yield takeLatest(actionTypes.SINGLE_DEACTIVATE_FD_TENURE_REQUEST, singleDeactivateFdTenure)
}
